import { render, staticRenderFns } from "./LoginComponentProducts.vue?vue&type=template&id=51924aae&scoped=true"
import script from "./LoginComponentProducts.vue?vue&type=script&lang=js"
export * from "./LoginComponentProducts.vue?vue&type=script&lang=js"
import style0 from "./LoginComponentProducts.vue?vue&type=style&index=0&id=51924aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51924aae",
  null
  
)

export default component.exports